export class StripeACHPaymentIntentStatusError extends Error {
  constructor(message) {
    super(message);
    this.name = 'StripeACHPaymentIntentStatusError';
  }
}
